
import { Vue, Component, Emit } from 'vue-property-decorator'
import { ModalBox as Modal } from '@mg/micro/vue2/ModalBox'
import CloseButton from '@mg/web-components/Atoms/Buttons/CloseButton'
import LoginForm from '../LoginForm.vue'
import { GQL_LOCAL_ACCOUNT } from '~/graphql/gqlLocal/localAccount'
import { GET_BASIC_USER_INFO } from '~/graphql/gql/user'
import { GQLLocalAccount } from '~/graphql/__generated__/interfacesLocal'
import { GQLUser } from '~/graphql/__generated__/interfaces'

@Component<ModalLogin>({
  apollo: {
    account: GQL_LOCAL_ACCOUNT,
    user: {
      query: GET_BASIC_USER_INFO,
      skip() {
        return !this.$shopConfig.user.id && !this.account?.isLogged
      },
    },
  },
  components: { CloseButton, LoginForm, Modal },
})
export default class ModalLogin extends Vue {
  account: GQLLocalAccount
  user: GQLUser

  @Emit('onModalClose')
  onModalClose() {
    return true
  }
}
